import type { Side } from './espn'

/**
 * How wide the spread bar's fill is, and which way it grows.
 *
 * A yard-line track with a hash at the centre, filled from the middle toward
 * the favourite. It exists so the youngest player can read a mismatch without
 * doing arithmetic, which is also why it is capped: past four touchdowns the
 * bar stops growing, because nobody needs to see the width of the difference
 * between 30 points and 45.
 *
 * Ported unchanged from the app this replaces - the numbers are the ones that
 * were already tuned against real slates.
 */
const CAP = 28

export function barGeometry(
  spread: number | null,
  favSide: Side | null,
): { side: Side | null; pct: number } {
  // No line, or a true pick-em: an empty track, not a bar of zero width
  // pointing somewhere arbitrary.
  if (spread === null || favSide === null) return { side: null, pct: 0 }
  return { side: favSide, pct: (Math.min(spread, CAP) / CAP) * 50 }
}
